export default "__VITE_ASSET__9ip3X$vr__"